import "../dashboard.css";
import {Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';




ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    Tooltip,
    Legend,
    PointElement,
    ChartDataLabels
);

export default function UsersByMonth({ data }) {

    const convertMonth = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString('default', { month: 'long' });
    }
    return (        
        <div>
            {
                data ?  
                    <Line
                        data={{
                            labels: Object.keys(data).map(month => convertMonth(month)),
                            datasets: [
                                {
                                    label: 'Users by Month',
                                    data: Object.values(data).map(diseases => diseases.length),
                                    fill: true,
                                    backgroundColor: 'rgba(75,192,192,0.2)',
                                    borderColor: 'rgba(12, 114, 247, 1)',
                                    tension: 0.1,
                                },
                            ],
                        }}
                        options={{
                            responsive: true,
                            plugins: {
                                legend: {
                                    position: 'top',
                                },
                                datalabels: {
                                    display: true, // Enable data labels
                                    color: 'black', // Color of the labels
                                    anchor: 'end', // Position of the label relative to the point (e.g., 'end', 'center', 'start')
                                    align: 'top', // Alignment of the label text
                                    formatter: (value) => value,
                                },
                            },  
                            scales: {
                                y: {
                                    beginAtZero: true,
                                    precision: 0,
                                },
                            },
                        }}
                        className="linechartmonth"
                    />
                    : <p>Loading...</p>
            }
        </div>
    );
}